
    
        var maquetteH = require('maquette').h;
        var h = function(selector, props, children) {
          var attributes = Object.assign({}, props.attributes || {}, props);
          delete attributes["attributes"];

          // This should be done by pug-vdom, oh well...
          if (attributes.class) {
            selector += "." + attributes.class.trim().split(/ +/).join(".");
            delete attributes["class"];
          }

          return maquetteH(selector, attributes, children);
        }
      ;
    function render(context, h, text = (string) => string) {
  if (!pugVDOMRuntime) throw "pug-vdom runtime not found.";
  var runtime = pugVDOMRuntime
  var locals = context;
  var self = locals;
  var remainingKeys = pugVDOMRuntime.enterLocalsScope(locals);
  for (var prop in remainingKeys) {
    eval('var ' + prop + ' =  locals.' + prop);
  }
  var n0Child = []
  var n8Child = []
  var n9Child = []
  n9Child = n9Child.concat(text(this.t('.unused_scenes')))
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'text'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n9 = h('div', props, n9Child)
  n8Child.push(n9)
  var n10Child = []
  n10Child = n10Child.concat(text(this.t('.delete_all')))
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'button'},{name:'class', val: 'is-danger'},{name:'class', val: 'is-small'},{name:'type', val: "button"},{name:'onclick', val: this.promptDeleteAllUnusedScenes}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n10 = h('button', props, n10Child)
  n8Child.push(n10)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'is-flex'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n8 = h('header', props, n8Child)
  n0Child.push(n8)
  var n11Child = []
  var v12 = this.unusedScenes
  Object.keys(v12).forEach(function (k13) {
    var scene = v12[k13]
    var n14Child = []
    var n15Child = []
    var n16Child = []
    n16Child = n16Child.concat(text(scene._name || this.t('.untitled')))
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'card-header-title'},{name:'class', val: 'name'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n16 = h('div', props, n16Child)
    n15Child.push(n16)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'card-header'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n15 = h('header', props, n15Child)
    n14Child.push(n15)
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'scene'},{name:'class', val: 'card'},{name:'onclick', val: this._sceneClicked.bind(this, scene)},{name:'key', val: scene}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n14 = h('div', props, n14Child)
    n11Child.push(n14)
  }.bind(this))
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'scene-list'},{name:'class', val: 'is-flex'},{name:'class', val: 'is-flex-wrap-wrap'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n11 = h('div', props, n11Child)
  n0Child.push(n11)
  pugVDOMRuntime.exitLocalsScope()
  return n0Child
}
;
    module.exports = function(locals) {
      locals = Object.assign(window.DEFAULT_TEMPLATE_LOCALS || {}, locals || {});
      return render.call(this, locals, h);
    };
  